<template>
    <ui-modal v-ref:confirm-modal :title="title">
        <div>

            <div class="row">
                <div class="col-md-12">
                    <div style="padding: 0 5px">
                        {{ text }}
                        <slot name="message"></slot>
                    </div>
                </div>
            </div>
            <div class="row" v-if="needComment || validationText">
                <div class="col-md-12">
                    <div v-if="validationText" :class="{'has-validation-errors': error}">
                        <form-text lable="Digite a confirmação"
                                   :model.sync="validation"
                                   :placeholder="typeValidationText">
                        </form-text>
                        <div class="error-bag" v-if="error">
                        <span class="help-block">
                            Confirme a ação
                        </span>
                        </div>
                    </div>
                    <div v-if="needComment" :class="{'has-validation-errors': error}">
                        <form-textarea lable="Comentário"
                                       :placeholder="typeValidationText"
                                       :model.sync="form.comment">
                        </form-textarea>
                        <div class="error-bag" v-if="error">
                            <span class="help-block">
                                Escreva um comentário do por que está fazendo isso.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="footer">
            <button class="btn green" :disabled="! confirmed" @click="acceptClick">
                {{ acceptText }}
            </button>

            <button class="btn red" @click="cancelClick">
                {{ cancelText }}
            </button>
        </div>
    </ui-modal>
</template>


<style scoped>

</style>

<script>
const voidFunction = () => {
};
export default {
    name: 'ui-confirm',

    props: {
        title: {default: "Realmente deseja fazer isso?"},
        text: {},
        placeholder: {},
        accept: {
            default: (form) => voidFunction
        },
        cancel: {
            default: (form) => voidFunction
        },
        needComment: {
            default: false
        },
        validationText: {},
        acceptText: {default: "Aceitar"},
        cancelText: {default: "Cancelar"}
    },

    data() {
        return {
            validation: null,
            error: false,
            form: {
                comment: null
            }
        }
    },

    computed: {
        typeValidationText() {
            if (this.placeholder) {
                return this.placeholder;
            }
            return `Digite "${this.validationText}" para confirmar`

        },
        confirmed() {
            return (
                (this.validationText && this.validationText !== this.validation) ||
                (this.needComment && this.form.comment) ||
                (! this.validationText && ! this.needComment)
            )
        }
    },
    methods: {
        show() {
            this.$refs.confirmModal.show();
        },
        hide() {
            this.$refs.confirmModal.hide();
        },
        acceptClick() {

            if (!this.confirmed) {
                this.error = true;
                return;
            }

            this.accept(this.form);
            this.hide();
        },
        cancelClick() {

            this.cancel(this.form);
            this.hide();
        }
    }
}
</script>



// WEBPACK FOOTER //
// Confirm.vue?5b3cc00a